/**
 * Wallet Service
 * Handles all wallet-related API calls
 */

import { apiGet } from './apiClient';
import API_CONFIG from './apiConfig';

/**
 * Get user's wallet balance
 * @returns {Promise}
 */
export const getWalletBalance = async () => {
  return apiGet(API_CONFIG.endpoints.wallet);
};

/**
 * Get user's wallet transaction history
 * @returns {Promise}
 */
export const getWalletTransactions = async () => {
  return apiGet(API_CONFIG.endpoints.walletTransactions);
};

